import React, { useState } from 'react';
import { getToken } from '../../../../utils/Token';
import Button from '@mui/material/Button';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';


export default function ReportView({ Url, displayName ,show}) {
  const [token, setToken] = useState(getToken())

  return (
    <>
  
    <form action={Url}  method="post"
      target="_blank">
      <input type="hidden" name="token" value={token} />
      {/* <button type='submit' >{displayName}</button> */}
      {/*  */}
      <Button variant="text"type='submit' style={{padding:"0",textTransform:"capitalize"}}>
        <a  style={{ color: '#2A93DB', cursor: "pointer", textDecoration: "none",fontSize:"1rem"}}><InsertDriveFileOutlinedIcon /> {displayName}</a></Button>
    </form>
    </>
  )
}
